import { render, staticRenderFns } from "./Surcharges.vue?vue&type=template&id=6dd926c6&"
import script from "./Surcharges.vue?vue&type=script&lang=js&"
export * from "./Surcharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports